'use strict';
/*

    To use this input widget adapter you need to register it with your
    adapter registry.

*/

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { createVNode, createComponentVNode } from "inferno";
import { Component } from 'inferno';
import { Adapter } from 'component-registry';
import { findDOMNode } from 'inferno-extras';
import { interfaces } from 'isomorphic-schema';
import { IFormRowWidget } from '../interfaces';
import { animateOnAdd, animateOnRemove } from 'inferno-animation';
import { renderString } from './common';
import { FormGroup, Label as _bs_Label } from 'inferno-bootstrap';
import { ErrorMsg, HelpMsg, unpackInvariantErrors, Label } from '../FormRowHelpers';
/*
    PROPS:
    - animation: animation css class prefix
    - submitted: bool, has been submitted
    - field:  isomorphic-schema field validator object
    - errors: isomorphic-schema field and server error object { fieldErrors, serverErrors } or undefined if no errors
    - id:     unique id of field
*/

var Row = /*#__PURE__*/function (_Component) {
  _inherits(Row, _Component);

  function Row() {
    _classCallCheck(this, Row);

    return _possibleConstructorReturn(this, _getPrototypeOf(Row).apply(this, arguments));
  }

  _createClass(Row, [{
    key: "componentDidMount",
    // TODO: Add animation support
    // support required
    value: function componentDidMount() {
      if (this.props.formIsMounted) {
        animateOnAdd(findDOMNode(this), 'InfernoFormlib-Row--Animation');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      animateOnRemove(findDOMNode(this), 'InfernoFormlib-Row--Animation');
    }
  }, {
    key: "render",
    value: function render(_ref) {
      var validationError = _ref.validationError,
          adapter = _ref.adapter,
          submitted = _ref.submitted,
          options = _ref.options,
          children = _ref.children,
          id = _ref.id;
      var field = adapter.context;
      var invariantError = unpackInvariantErrors(this.props.validationError, this.props.namespace);
      return createComponentVNode(2, FormGroup, {
        "id": this.props.namespace.join('.') + '__Row',
        children: [field.label && createComponentVNode(2, Label, {
          "id": id,
          "options": options,
          children: field.label
        }), createVNode(1, "div", "InfernoFormlib-RowFieldContainer", children, 0), validationError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": validationError,
          "submitted": submitted,
          "options": options
        }) : null, invariantError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": invariantError,
          "submitted": submitted,
          "options": options
        }) : null, createComponentVNode(2, HelpMsg, {
          "field": field,
          "text": field.help,
          "required": field._isRequired && !validationError,
          "options": options
        })]
      });
    }
  }]);

  return Row;
}(Component);

new Adapter({
  implements: IFormRowWidget,
  adapts: interfaces.IBaseField,
  Component: Row,
  doesNotRenderLabel: function doesNotRenderLabel() {
    return this.context.label ? false : true;
  }
});

var ObjectRow = /*#__PURE__*/function (_Component2) {
  _inherits(ObjectRow, _Component2);

  function ObjectRow() {
    _classCallCheck(this, ObjectRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectRow).apply(this, arguments));
  }

  _createClass(ObjectRow, [{
    key: "componentDidMount",
    // TODO: Add animation support
    // support required
    value: function componentDidMount() {
      if (this.props.formIsMounted) {
        animateOnAdd(findDOMNode(this), 'InfernoFormlib-Row--Animation');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      animateOnRemove(findDOMNode(this), 'InfernoFormlib-Row--Animation');
    }
  }, {
    key: "render",
    value: function render(_ref2) {
      var validationError = _ref2.validationError,
          adapter = _ref2.adapter,
          submitted = _ref2.submitted,
          options = _ref2.options,
          children = _ref2.children,
          id = _ref2.id;
      var field = adapter.context;
      var invariantError = unpackInvariantErrors(this.props.validationError, this.props.namespace);
      return createComponentVNode(2, FormGroup, {
        "className": "InfernoFormlib-ObjectRow",
        children: [field.label && createComponentVNode(2, Label, {
          "id": id,
          "options": options,
          children: field.label
        }), validationError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": validationError,
          "submitted": submitted,
          "options": options
        }) : null, invariantError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": invariantError,
          "submitted": submitted,
          "options": options
        }) : null, field.help ? createComponentVNode(2, HelpMsg, {
          "field": field,
          "text": field.help,
          "required": field._isRequired,
          "options": options
        }) : null, createVNode(1, "div", "InfernoFormlib-RowFieldContainer", children, 0)]
      });
    }
  }]);

  return ObjectRow;
}(Component);

new Adapter({
  implements: IFormRowWidget,
  adapts: interfaces.IObjectField,
  Component: ObjectRow,
  doesNotRenderLabel: function doesNotRenderLabel() {
    return this.context.label ? false : true;
  }
});

var ListRow = /*#__PURE__*/function (_Component3) {
  _inherits(ListRow, _Component3);

  function ListRow() {
    _classCallCheck(this, ListRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListRow).apply(this, arguments));
  }

  _createClass(ListRow, [{
    key: "componentDidMount",
    // TODO: Add animation support
    // support required
    value: function componentDidMount() {
      if (this.props.formIsMounted) {
        animateOnAdd(findDOMNode(this), 'InfernoFormlib-Row--Animation');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      animateOnRemove(findDOMNode(this), 'InfernoFormlib-Row--Animation');
    }
  }, {
    key: "render",
    value: function render(_ref3) {
      var validationError = _ref3.validationError,
          adapter = _ref3.adapter,
          submitted = _ref3.submitted,
          options = _ref3.options,
          children = _ref3.children,
          id = _ref3.id;
      var field = adapter.context;
      var invariantError = unpackInvariantErrors(this.props.validationError, this.props.namespace);
      return createComponentVNode(2, FormGroup, {
        "className": "InfernoFormlib-ListRow",
        children: [field.label && createComponentVNode(2, Label, {
          "id": id,
          "options": options,
          children: field.label
        }), validationError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": validationError,
          "submitted": submitted,
          "options": options
        }) : null, invariantError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": invariantError,
          "submitted": submitted,
          "options": options
        }) : null, field.help ? createComponentVNode(2, HelpMsg, {
          "field": field,
          "text": field.help,
          "required": field._isRequired,
          "options": options
        }) : null, createVNode(1, "div", "InfernoFormlib-RowFieldContainer", children, 0)]
      });
    }
  }]);

  return ListRow;
}(Component);

new Adapter({
  implements: IFormRowWidget,
  adapts: interfaces.IListField,
  Component: ListRow,
  doesNotRenderLabel: function doesNotRenderLabel() {
    return this.context.label ? false : true;
  }
});

var CheckboxRow = /*#__PURE__*/function (_Component4) {
  _inherits(CheckboxRow, _Component4);

  function CheckboxRow() {
    _classCallCheck(this, CheckboxRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxRow).apply(this, arguments));
  }

  _createClass(CheckboxRow, [{
    key: "componentDidMount",
    // TODO: Add animation support
    // support required
    value: function componentDidMount() {
      if (this.props.formIsMounted) {
        animateOnAdd(findDOMNode(this), 'InfernoFormlib-Row--Animation');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      animateOnRemove(findDOMNode(this), 'InfernoFormlib-Row--Animation');
    }
  }, {
    key: "render",
    value: function render(_ref4) {
      var validationError = _ref4.validationError,
          adapter = _ref4.adapter,
          submitted = _ref4.submitted,
          options = _ref4.options,
          children = _ref4.children,
          id = _ref4.id;
      var field = adapter.context;
      var invariantError = unpackInvariantErrors(this.props.validationError, this.props.namespace);
      return createComponentVNode(2, FormGroup, {
        "id": this.props.namespace.join('.') + '__Row',
        "check": true,
        children: [createVNode(1, "div", "InfernoFormlib-RowFieldContainer", createComponentVNode(2, _bs_Label, {
          "id": id,
          "check": true,
          children: [children, renderString(field.label, options && options.lang)]
        }), 2), validationError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": validationError,
          "submitted": submitted,
          "options": options
        }) : null, invariantError ? createComponentVNode(2, ErrorMsg, {
          "field": field,
          "validationError": invariantError,
          "submitted": submitted,
          "options": options
        }) : null, createComponentVNode(2, HelpMsg, {
          "field": field,
          "text": field.help,
          "required": field._isRequired,
          "options": options
        })]
      });
    }
  }]);

  return CheckboxRow;
}(Component);

new Adapter({
  implements: IFormRowWidget,
  adapts: interfaces.IBoolField,
  Component: CheckboxRow,
  doesNotRenderLabel: function doesNotRenderLabel() {
    return this.context.label ? false : true;
  }
});
export { CheckboxRow, ObjectRow, Row, ErrorMsg, HelpMsg, Label, unpackInvariantErrors };